import React from 'react';
import PropTypes from 'prop-types';

import CardBig from './CardBig';

const Columns1Centered = ({ cards, showPopupCard }) => (
  <div className="columns is-centered is-multiline">
    {cards.edges.map(({ node }, key) => {
      const dataPopupCard = {
        body: node.html,
        title: node.frontmatter.title,
      };

      return (
        <CardBig
          dataPopupCard={dataPopupCard}
          key={key}
          showPopupCard={showPopupCard}
          text={node.frontmatter.short}
          title={node.frontmatter.title}
        />
      );
    })}
  </div>
);

Columns1Centered.propTypes = {
  cards: PropTypes.objectOf(PropTypes.array).isRequired,
  showPopupCard: PropTypes.func,
};

Columns1Centered.defaultProps = {
  showPopupCard: f => f,
};

export default Columns1Centered;
